import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

const Pensionsraadgivning = () => {
  const questions = [
    "Sparer jeg nok op til pension?",
    "Sparer jeg op i den rigtige type pensionsordning?",
    "Hvornår bør mine pensioner komme til udbetaling?",
    "Hvordan ser min økonomiske situation ud som pensionist?",
    "Kan jeg tillade mig at gå tidligt på pension?",
    "I hvilken rækkefølge bør mine pensioner udbetales?",
    "Kan nogle af mine pensionsordninger lægges sammen?",
    "Skal jeg spare op i bank eller pensionskasse?"
  ];

  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Pensionsrådgivning: Økonomisk rådgivning til pension</title>
        <meta name="description" content="Vi tilbyder uvildig pensionsrådgivning med fokus på at optimere din pensionsordning. Vi hjælper både dig på arbejdsmarkedet og pensionisten. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-4xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Pensionsrådgivning</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-10 break-words">Pensionsrådgivning</h1>

        <div className="flex flex-col md:flex-row gap-10 mb-12">
          <div className="md:w-1/3">
            <img 
              src="https://assets.auxodev.dk/assets/3ae65674-a84a-41bf-9a95-918b20317861/6e2af473-83c8-4c8b-8352-12b8ddc7a123.jpg" 
              alt="pensionsrådgivning" 
              className="rounded-2xl shadow-lg w-full"
            />
          </div>
          <div className="md:w-2/3 prose prose-slate prose-lg">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Få optimal pensionsrådgivning</h2>
            <p>
              Uanset om du er ny på arbejdsmarkedet, overvejer pension inden for få år, eller allerede er pensionist, hjælper vi dig med at skabe overblik over en kompleks verden af regler og produkter.
            </p>
            <p>
              Den rigtige sammensætning af din pension kan betyde en markant forskel i din økonomiske tryghed og livskvalitet gennem hele livet.
            </p>
          </div>
        </div>

        <div className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-200 mb-12">
          <h3 className="text-xl font-bold text-slate-900 mb-6">
            Vi hjælper dig med svar på spørgsmål som:
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {questions.map((q, i) => (
              <li key={i} className="flex items-start">
                <CheckCircle2 size={18} className="text-[#b60f00] mr-3 shrink-0 mt-1" />
                <span className="text-slate-700 text-sm leading-relaxed">{q}</span>
              </li>
            ))}
          </ul>
          <div className="mt-10 text-center">
            <Link 
              to="/kontakt-os" 
              className="inline-flex items-center bg-[#b60f00] text-white px-8 py-4 rounded-xl font-bold hover:bg-[#a00d00] transition-all shadow-md active:scale-95"
            >
              Bestil et gratis uforpligtende møde her
            </Link>
          </div>
        </div>

        <div className="prose prose-slate prose-lg max-w-none">
          <p>
            FinansOptimering hjælper dig med at fastlægge den optimale pensionsstrategi. Vi tager højde for fleksibilitet, formue, modregningsregler og skat. 
          </p>
          <p>
            Vi udarbejder en <strong>Seniorplan</strong>, der synliggør din fremtidige økonomi og sikrer den mest fordelagtige udbetalingsrækkefølge.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Pensionsraadgivning;
